import React from 'react';
import clsx from 'clsx';

import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import BackupIcon from '@material-ui/icons/Backup';

import { UPLOAD_OPTIONS } from '@shared/constants';

import UploadActionDialog from './upload-action';
import FileSelectionDialog from './upload-dialog';

const noop = () => {};
const paperElevation = 1;
const defaultState = {
  openUploadActionDialog: false,
  openFileSelectionDialog: false,
  uploadAction: UPLOAD_OPTIONS.CREATE_OR_UPDATE_RULE,
  selectedFile: null,
};
const UploadData = ({ isDowloadComplete = false, handleUpload = noop }) => {
  const [state, setState] = React.useState(defaultState);

  const handleFileSelection = event => {
    let selectedFile = null;
    if (event.currentTarget.files && event.currentTarget.files.length > 0) {
      selectedFile = event.currentTarget.files[0];
    }

    if (!selectedFile) {
      return;
    }

    setState(prevState => ({
      ...prevState,
      selectedFile,
    }));
  };

  return (
    <>
      <Paper
        className={clsx(
          'd-flex f-justify-center flex-column mr-10 ml-10 p-6 mt-5'
        )}
        elevation={paperElevation}
      >
        <div className='d-flex f-justify-between'>
          <Typography variant='h6'>Instructions</Typography>
          <Button
            disabled={!isDowloadComplete}
            onClick={() => {
              setState(prevState => ({
                ...prevState,
                openFileSelectionDialog: true,
              }));
            }}
            startIcon={<BackupIcon />}
            variant='outlined'
            color='primary'
          >
            Upload File
          </Button>
        </div>
        <Typography variant='body2'>
          1. Apply desired filters and download template/existing rules
        </Typography>
        <Typography variant='body2'>
          2. Upload updated file and choose desired action
        </Typography>
        <Typography variant='body2'>
          Find more details on our PSI site{' '}
          <Typography
            variant='body2'
            component='a'
            href='https://psi.ps.ringcentral.com/dount-advance-rules/'
            target='_blank'
            className='color-text-link'
          >
            here
          </Typography>
        </Typography>
      </Paper>
      <UploadActionDialog
        isOpen={state.openUploadActionDialog}
        uploadAction={state.uploadAction}
        onClose={() => {
          setState(defaultState);
        }}
        onChange={event => {
          setState(prevState => ({
            ...prevState,
            uploadAction: event?.target?.value,
          }));
        }}
        handleUpload={() => {
          setState(defaultState);
          handleUpload(state.selectedFile, state.uploadAction);
        }}
      />
      <FileSelectionDialog
        isOpen={state.openFileSelectionDialog}
        selectedFile={state.selectedFile}
        onClose={() => {
          setState(prevState => ({
            ...prevState,
            openFileSelectionDialog: false,
            selectedFile: null,
          }));
        }}
        onChange={handleFileSelection}
        handleUpload={() => {
          setState(prevState => ({
            ...prevState,
            openUploadActionDialog: true,
            openFileSelectionDialog: false,
          }));
        }}
      />
    </>
  );
};
export default UploadData;
